<template>
  <div>

    <!-- SVIP -->
    <audio src="@/assets/MP3/SVIP.mp3" ref="SVIP"></audio>
    <!-- 定额 -->
    <audio src="@/assets/MP3/quota.mp3" ref="quota"></audio>
    <!-- 潜力 -->
    <audio src="@/assets/MP3/potential.mp3" ref="potential"></audio>
  </div>
</template>
<script>
export default {
  props: {
    attribute: { type: Number }
  },
  data() {
    return {
    };
  },
  mounted() {


  },
  methods: {
    playAttribute() {
      if (this.attribute == 1) {
        this.$refs.quota.play(); //播放
      } else if (this.attribute == 3) {// 潜力客户
        this.$refs.potential.play(); //播放
      } else if (this.attribute == 2) {  // SVIP
        this.$refs.SVIP.play(); //播放
      }
    }
  }
}
</script>
<style lang='scss' scoped></style>